import { useEffect, useState } from "react";
import {
  CardSummaries,
  CardSummaryType,
  peekCardSummary,
  readCardSummary,
} from "../../excel/datasources/cardSummaries";
import { useDatasources } from "../context/DatasourceContext";

export const useCardSummary = <T extends CardSummaryType>(type: T): CardSummaries[T] | undefined => {
  const { dataVersion } = useDatasources();
  const [summary, setSummary] = useState<CardSummaries[T] | undefined>(() => peekCardSummary(type));

  useEffect(() => {
    let isCurrent = true;
    readCardSummary(type)
      .then((value) => {
        if (isCurrent) setSummary(value);
      })
      .catch(() => undefined);
    return () => {
      isCurrent = false;
    };
  }, [type, dataVersion]);

  return summary;
};
